import { render, staticRenderFns } from "./DebtorReport.vue?vue&type=template&id=0308dd26&scoped=true&"
import script from "./DebtorReport.vue?vue&type=script&lang=js&"
export * from "./DebtorReport.vue?vue&type=script&lang=js&"
import style0 from "./DebtorReport.vue?vue&type=style&index=0&id=0308dd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0308dd26",
  null
  
)

export default component.exports